import { Waves } from 'lucide-react';

export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center px-6 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-teal-500/10 rounded-full blur-[120px]" />
      <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] bg-blue-500/8 rounded-full blur-[100px]" />
      
      {/* Content */}
      <div className="relative z-10 text-center max-w-lg">
        {/* Logo */}
        <div className="w-16 h-16 bg-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-8 shadow-lg shadow-teal-500/20">
          <Waves className="w-8 h-8 text-white" />
        </div>
        
        {/* Title */}
        <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight mb-4">
          Microsafe
        </h1>
        
        <p className="text-lg text-slate-400 mb-10 leading-relaxed">
          Havbruksovervaking og algeanalyse.<br />
          Ny plattform kjem snart.
        </p>
        
        {/* Coming soon badge */}
        <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-slate-800/80 border border-slate-700/50 rounded-full">
          <span className="w-2 h-2 bg-teal-400 rounded-full animate-pulse" />
          <span className="text-sm text-slate-300 font-medium">Under utvikling</span>
        </div>
      </div>
      
      {/* Footer */}
      <div className="absolute bottom-8 text-xs text-slate-600">
        Microsafe AS
      </div>
    </div>
  );
}
